/* eslint-disable react/jsx-props-no-spreading */
import { string, func, number, bool } from 'prop-types';
import React from 'react';
import Plus from '../../../assets/icons/navigation/plus.svg';
import Icon from '../../Icon';
import { dt } from '../../../helpers/Utils/GetTailwindToken';

const Header = React.memo(
    ({ isExpanded, onClick, index, header, toggleControlLeft, iconSize, parentSection }) => {
        const config = {
            button: {
                'aria-controls':
                    parentSection.length > 0
                        ? `${parentSection}-accordion-panel-${index}`
                        : `accordion-panel-${index}`,
                'aria-expanded': isExpanded,
                className: dt(['flex', 'items-center', 'py-4', 'px-6', 'w-full']),
                id:
                    parentSection.length > 0
                        ? `${parentSection}-accordion-button-${index}`
                        : `accordion-button-${index}`,
                onClick,
                tabIndex: '0',
            },
            icon: {
                'aria-hidden': 'true',
                children: <Plus />,
                className: `${toggleControlLeft ? dt(['mr-4']) : dt(['ml-auto'])}`,
                focusable: 'false',
                height: iconSize,
                style: {
                    transform: `rotate(${isExpanded ? '-45' : '90'}deg)`,
                    transition: 'transform 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                },
                width: iconSize,
            },
            text: {
                className: dt([
                    'font-open-sans-semibold',
                    'text-normal',
                    'flex',
                    'items-center',
                    'capitalize',
                ]),
            },
        };

        return (
            <div aria-level="3" role="heading">
                <button {...config.button} type="button">
                    {toggleControlLeft && <Icon {...config.icon} />}
                    <span {...config.text}>{header}</span>
                    {!toggleControlLeft && <Icon {...config.icon} />}
                </button>
            </div>
        );
    },
    (prevProps, nextProps) => {
        return (
            prevProps.header === nextProps.header && prevProps.isExpanded === nextProps.isExpanded
        );
    }
);

Header.propTypes = {
    isExpanded: bool.isRequired,
    onClick: func.isRequired,
    index: number.isRequired,
    header: string.isRequired,
    toggleControlLeft: bool.isRequired,
    iconSize: string.isRequired,
    parentSection: string.isRequired,
};

export default Header;
